import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The phytoremediation approach is an eco-friendly solution for the
              treatment of contaminated soils and water using plants. Common
              plants in wetlands such as <em>Typha</em> sp., <em>Cyperus</em>{" "}
              sp., <em>Ludwigia</em> sp., <em>Pistia stratiotes</em>,{" "}
              <em>Polygonum</em> sp., <em>Alternanthera philoxeroides </em>and{" "}
              <em>Spirodela</em> sp., have good remediation potential due to
              their metal uptake ability. Macrophytes have the ability for the
              uptake of heavy metals such as Cd, Pb, Zn, Ni, Cr and Cd, which
              will be the low cost option in the remediation of polluted soil
              and water. As the uptake of heavy metals by the macrophytes during
              the 4<sup>th </sup>week was within the normal range, suggests that
              it can be used as fodder. Select local macrophyte species use in
              the constructed wetland systems would aid in remediation through
              removal of contaminants (nutrients and heavy metals) from domestic
              and industrial wastewater. Ensuring zero discharge from industries
              would be the best option toward ensuring heavy metals not getting
              into biotic food chain. Growing macrophytes in the flood plains of
              water bodies in rural area helps in treating agriculture run-off
              containing nutrients and heavy metals.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
